/**
 * BannerTitleButton component
 * This is the hero for the store
 * It will render both versions (desktop and mobile)
 * @returns <BannerTitleButton />
 */

import Button from "./Button";
import TitleAndButton from "./TitleAndButton";
import SubtitleAndLink from "./SubtitleAndLink";
import BoxWithBackgroundContainer from "./BoxWithBackgroundContainer";

const BannerTitleButton = (props) => {
    const {
        imageDesktop,
        imageMobile,
        title,
        subtitle,
        color,
        buttons,
        titleItems,
        linkConfig,
        background,
        items,
        extraText = [],
        extraClass,
        forceNoRepeatBackground
    } = props;

    const desktopBackgroundStyle = forceNoRepeatBackground
        ? {
            backgroundImage: `url(${imageDesktop})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }
        : { backgroundImage: `url(${imageDesktop})` };

    const mobileBackgroundStyle = forceNoRepeatBackground
        ? {
            backgroundImage: `url(${imageMobile})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }
        : { backgroundImage: `url(${imageMobile})` };

    return (
        <>
            <section className={`banner_title_button-desktop ${titleItems && "items"} ${extraClass ? extraClass : ""}`} style={desktopBackgroundStyle}>
                <div className="container">
                    <TitleAndButton title={title} subtitle={subtitle} color={color} buttons={buttons} />
                    {
                        titleItems
                            ?
                            <div className="banner_title_button_bottom">
                                <div className="wrapper">
                                    <div className="banner_title_button_bottom_title">
                                        <p>{titleItems}</p>

                                        <Button {...linkConfig} />
                                    </div>
                                </div>

                                <BoxWithBackgroundContainer background={background} items={items} />
                            </div>
                            :
                            // I cant check if exists here because its an array
                            // So I have to check for the length
                            // If its > 0, there is one or more elements
                            extraText.length > 0
                                ?
                                <div className="banner_title_button_bottom_extra_text wrapper">
                                    {extraText.map((text, i) => {
                                        return (
                                            <div className="content" key={i}>
                                                <h4 className="banner_title_button_bottom_extra_text_big" style={{ color: color }}>{text.big}</h4>
                                                <p className="banner_title_button_bottom_extra_text_small" style={{ color: color }}>{text.small}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                                :
                                ""
                    }
                </div>
            </section>

            <section className={`banner_title_button-mobile ${titleItems && "items"} ${extraClass ? extraClass : ""}`}>
                <div style={mobileBackgroundStyle}>
                    <div className="container">
                        <TitleAndButton title={title} subtitle={subtitle} color={color} buttons={buttons} />
                    </div>
                </div>

                {
                    titleItems
                        ?
                        <div className="banner_title_button_bottom">
                            <SubtitleAndLink subtitle={titleItems} btnConfig={linkConfig} />
                            <BoxWithBackgroundContainer items={items} />
                        </div>
                        :
                        extraText.length > 0
                            ?
                            <div className="banner_title_button_bottom_extra_text wrapper">
                                {extraText.map((text) => {
                                    return (
                                        <div className="content">
                                            <h4 className="banner_title_button_bottom_extra_text_big" style={{ color: color }}>{text.big}</h4>
                                            <p className="banner_title_button_bottom_extra_text_small" style={{ color: color }}>{text.small}</p>
                                        </div>
                                    )
                                })}
                            </div>
                            :
                            ""
                }
            </section>
        </>
    )
}

export default BannerTitleButton
